import { createApp } from 'vue'
import App from './App.vue'

// EmailJS is configured entirely in src/services/EmailService.js, which passes the
// public key explicitly on every send. Do not call emailjs.init() here - it writes a
// second, competing public key into the SDK's global store.

createApp(App).mount('#app')
